import styled from 'styled-components';
import { toRem } from 'utils/helpers';

export const SearchPatientInputWrapper = styled.div`
  .input-inner {
    max-width: ${toRem(120)}rem;
  }
`;

export const SearchPatientWrapper = styled.form`
  display: flex;
  flex: 1;
  column-gap: var(--s3);
  row-gap: var(--s1);
  flex-wrap: wrap;
`;

export const SelectedPatientWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: ${toRem(320)}rem;
  margin-left: auto;

  p {
    font-size: ${toRem(16)}rem;
    color: var(--greenprimary);
    font-weight: 600;
    margin: 0;
    padding-top: var(--s2);
    white-space: nowrap;
    overflow: hidden;
    margin-right: var(--s1);
    text-overflow: ellipsis;
  }
`;
